import {
  CHILD_ITEMS_UPDATED_EVENT,
  DELIVERY_SLOTS_CHECKER_SERVICES_CHANGED,
} from "@/constants/constants";

import { ServicesChangedEvent, Services } from "@/types/serviceTypes";

export function removeDmsPrefix(inputString: string) {
  if (inputString.startsWith("DMS")) {
    return inputString.slice(3);
  } else {
    return inputString;
  }
}

export const emitServices = (services: Services = []) => {
  dispatchForAddToBasketESI(services);
  dispatchForDeliverySlotsChecker(services);
};

function dispatchForAddToBasketESI(services: Services) {
  const childItemsUpdatedEvent = new CustomEvent(CHILD_ITEMS_UPDATED_EVENT, {
    detail: {
      childItems: services.map(({ skuId, id }) => ({
        skuId,
        variantId: id,
      })),
    },
  });
  dispatchEvent(childItemsUpdatedEvent);
}

function dispatchForDeliverySlotsChecker(services: Services) {
  const selectedDeliveryServices = services
    .filter((service) => service.serviceType === "DeliveryService")
    .map((service) => removeDmsPrefix(service.skuId));

  const eventPayload: ServicesChangedEvent = {
    selectedDmsIds: selectedDeliveryServices,
  };
  const event = new CustomEvent(DELIVERY_SLOTS_CHECKER_SERVICES_CHANGED, {
    detail: {
      ...eventPayload,
    },
  });
  dispatchEvent(event);
}
